export const getS3AssetPath = (assetFilename: string) =>
  `${process.env.SHARED_ASSETS_BASE_URL}/${assetFilename}`;

const TABLE_SHAPES_S3_PREFIX = 'table-shapes/';

const HAS_EXTENSION = /\.[a-z0-9]+$/i;

/**
 * Builds the CDN URL for a table shape icon from its icon name.
 * Icons are stored in S3 at table-shapes/{iconName}.svg.
 * Appends .svg when the icon name has no extension.
 */
export const toSharedAssetsCdnUrl = (iconName: string): string => {
  if (!iconName?.trim()) {
    console.error('iconName is required');
    return '';
  }
  const filename = HAS_EXTENSION.test(iconName) ? iconName : `${iconName}.svg`;
  return getS3AssetPath(`${TABLE_SHAPES_S3_PREFIX}${filename}`);
};
